<template>
	<div class="form-group" v-if="scope">
		<!-- <label :for="id">{{ label }}</label> -->
		
			<input

			v-validate="validate"
			:data-vv-scope="scope"

			class="form-control"
			:class="{'is-invalid': errors.has(scope+'.'+name)}"

			:id="id"
			:type="passwordFieldType"
			:name="name"
			:autocomplete="autocomplete"
			:placeholder="placeholder"

			v-model="real_value"

			v-on:input="$emit('input', $event.target.value)"></input>
			<div v-if="errors.has(scope+'.'+name)" class="invalid-feedback"><small class="input_description">{{ errors.first(scope+'.'+name) }}</small></div>
		<div v-else><small class="input_description" v-if="description">{{description}}</small></div>

            
                <div class="input-icon" @click="switchVisibility">
                	<span v-if="passwordFieldType === 'password'">
                		<i class="fa fa-eye"></i>
                	</span>
                	<span v-else>
                		<i class="fa fa-eye-slash"></i>
                	</span>
                </div>
            

		

		
	</div>
	<div class="form-group" v-else>
		<!-- <label :for="id">{{ label }}</label> -->


			<input

			v-validate="validate"
			

			class="form-control"
			:class="{'is-invalid': errors.has(name)}"

			:id="id"
			:type="passwordFieldType"
			:name="name"
			:autocomplete="autocomplete"
			:placeholder="placeholder"

			v-model="real_value"

			v-on:input="$emit('input', $event.target.value)"></input>
			<div v-if="errors.has(name)" class="invalid-feedback"><small class="input_description">{{ errors.first(name) }}</small></div>
		<div v-else><small class="input_description" v-if="description">{{description}}</small></div>

                <div class="input-icon" @click="switchVisibility">
                	<span v-if="passwordFieldType === 'password'">
                		<i class="fa fa-eye"></i>
                	</span>
                	<span v-else>
                		<i class="fa fa-eye-slash"></i>
                	</span>
                </div>

		

		

	</div>
</template>

<script>

export default {
	name: 'CsInputToggle',
	inject: ['$validator'],
	props: {
		validate: {
			default: ''
		},
		// base
		value: {
			// type: String,
			default: ''
		},
		label: {
			type: String,
			default: 'text'
		},
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		placeholder: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		// statussen
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: ''
		},


		// misc
		autocomplete: {
			type: String,
			default: ''
		},
		scope: {
			type: String
		},
		passwordFieldType: {
    			type: String,
    			default: 'password'
    		}  
	},
	data(){
		
		return {
			real_value: this.value,
		}
	},
	methods: {
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  },
	watch: {
		value(newValue){
			if(this.real_value != newValue){
				this.real_value = newValue;
			}
		}
	}
}
</script>

<style lang="scss">
@import '../../styles/config';

</style>



// WEBPACK FOOTER //
// src/components/Forms/CsInputToggle.vue